// src/components/common/DateDisplay.jsx

import React from 'react';
import { convertToJalali } from '../../utils/dateConverter';

const DateDisplay = ({ isoDate, showTime = true }) => {
  const jalaliDate = convertToJalali(isoDate);
  
  return (
    <span className="jalali-date" dir="ltr">
      {showTime ? jalaliDate.fullDate : `${jalaliDate.year}/${jalaliDate.month}/${jalaliDate.day}`}
    </span>
  );
};

export default DateDisplay;
